/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Sleep_WeekdayInputs */

const en_us2_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On weekdays`)
};

const pt_br2_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante a semana`)
};

const es_419_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre semana`)
};

const pt_pt2_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante a semana`)
};

const fr_fr2_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En semaine`)
};

const de_de2_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter der Woche`)
};

const it_it2_profile_editors_sleep_weekday = /** @type {(inputs: Profile_Editors_Sleep_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nei giorni feriali`)
};

/**
* | output |
* | --- |
* | "On weekdays" |
*
* @param {Profile_Editors_Sleep_WeekdayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_sleep_weekday = /** @type {((inputs?: Profile_Editors_Sleep_WeekdayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Sleep_WeekdayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_sleep_weekday(inputs)
	if (locale === "es-419") return es_419_profile_editors_sleep_weekday(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_sleep_weekday(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_sleep_weekday(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_sleep_weekday(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_sleep_weekday(inputs)
	return en_us2_profile_editors_sleep_weekday(inputs)
});
export { profile_editors_sleep_weekday as "profile-editors.sleep_weekday" }